<script setup>
import en from '@/components/miscellaneous/cookie-policy/en.vue'
import nb from '@/components/miscellaneous/cookie-policy/nb.vue'

definePageMeta({
    layout: 'content-pages'
})
</script>
<template>
    <component :is="$i18n.locale === 'en' ? en : nb"></component>
</template>
